import {useNavigate} from "react-router-dom";

const HERO_PHOTO = "/public/hero/hero_engineer_single.jpg";

export const LandingHero = () => {
    const navigate = useNavigate();

    return (
        <section className="oec-hero position-relative overflow-hidden">
            {/* clipPathUnits=objectBoundingBox lets the arc scale with the photo container */}
            <svg width="0" height="0" className="position-absolute" aria-hidden="true">
                <defs>
                    <clipPath id="oecHeroArc" clipPathUnits="objectBoundingBox">
                        <path d="M0.02,0 C0.0,0.35 0.05,0.75 0.2,1 L1,1 L1,0 Z"/>
                    </clipPath>
                </defs>
            </svg>

            <div className="oec-hero-photo d-none d-lg-block">
                <div className="oec-hero-photo-frame" style={{clipPath: "url(#oecHeroArc)"}}>
                    <img
                        src={HERO_PHOTO}
                        alt="Energy professional in hard hat and safety vest"
                        width={750}
                        height={1000}
                        fetchPriority="high"
                        decoding="async"
                    />
                </div>
                <svg
                    className="oec-hero-arc"
                    viewBox="0 0 1 1"
                    preserveAspectRatio="none"
                    aria-hidden="true"
                >
                    <path
                        d="M0.02,0 C0.0,0.35 0.05,0.75 0.2,1"
                        fill="none"
                        stroke="#B9E4C0"
                        strokeWidth="26"
                        vectorEffect="non-scaling-stroke"
                    />
                    <path
                        d="M0.02,0 C0.0,0.35 0.05,0.75 0.2,1"
                        fill="none"
                        stroke="#5DB86C"
                        strokeWidth="8"
                        vectorEffect="non-scaling-stroke"
                        transform="translate(-0.012,0)"
                    />
                </svg>

                <div className="oec-hero-tagline" aria-hidden="true">
                    <div>Clean Energy</div>
                    <div>Green Jobs</div>
                    <div>Stronger Markets</div>
                    <div>A Sustainable</div>
                    <div className="oec-hero-tagline-last">Africa.</div>
                </div>
            </div>

            <img
                src={HERO_PHOTO}
                alt=""
                className="oec-hero-photo-mobile d-lg-none"
                width={750}
                height={1000}
                fetchPriority="high"
                decoding="async"
            />

            <div className="oec-hero-content">
                <h1 className="oec-hero-title">
                    Connect Energy Talent.<br/>
                    Find Energy Solutions.<br/>
                    <span className="text-oec-orange">Grow Across Africa.</span>
                </h1>
                <p className="oec-hero-subtitle">
                    One platform. More opportunities. We connect skilled professionals
                    with meaningful energy jobs and link businesses with verified suppliers,
                    products and partners across Africa.
                </p>
                <div className="oec-hero-actions">
                    <button className="oec-hero-btn oec-hero-btn-primary" onClick={() => navigate("/jobs")}>
                        <i className="far fa-user"/>
                        <span>Find Energy Jobs</span>
                        <i className="fas fa-arrow-right"/>
                    </button>
                    <button className="oec-hero-btn oec-hero-btn-secondary" onClick={() => navigate("/marketplace")}>
                        <i className="fas fa-city"/>
                        <span>Find Energy Products &amp; Suppliers</span>
                        <i className="fas fa-arrow-right"/>
                    </button>
                </div>
            </div>
        </section>
    );
};
